<template>
  <b-card>
    <h3>Booking Timeline</h3>
    <div class="timeline__card-body d-flex align-items-center">
      <div
        v-for="(el, idx) in states"
        :key="idx"
        class="d-flex flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        style="width:150px;gap:5px;"
      >
        <b-badge
          :variant="colorGenerator(el.state)"
          class="booking-status-badge"
        >
          <span>{{ snakeCaseToCamelCase(el.state) }}</span>
        </b-badge>
        <small v-if="el.actor && el.actor.actorType">Action By: {{ snakeCaseToCamelCase(el.actor.actorType) }}</small>
        <small v-else>-</small>
        <small class="text-muted">At: {{ el.createdAt | formatDate }}</small>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BBadge, BCard } from 'bootstrap-vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'

export const colorGenerator = status => {
  if (status === 'CREATED') return 'purple'
  if (status === 'ACCEPTED') return 'yellow'
  if (status === 'PROCESSED') return 'cyan'
  if (status === 'CANCELED' || status === 'CANCELLED') return 'danger'
  if (status === 'COMPLETED') return 'success'

  return status
}

export default {
  components: {
    BBadge,
    BCard,
  },
  props: {
    states: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      colorGenerator,
      snakeCaseToCamelCase,
    }
  },
}
</script>
  <style scoped>
  .timeline__card-body {
  gap:15px;
    flex-wrap: wrap
  }
  .booking-status-badge {
    padding:8px;
    border-radius: 15px;
}
  </style>
